<template>
  <div>
    <CRow class="bg-white py-3 px-5 align-items-center">
      <CCol md="3">
        <span class="h5">{{ $t('automation.flow.header.title') }}</span>
        <CBadge class="px-3 py-2 mx-3 text-uppercase" :class="badgeByStatus.classes">{{ badgeByStatus.translation }}</CBadge>
        <div v-if="isLoadingSave" class="d-inline-block">
          <img style="width: 30px" src="img/Gif_autosave.gif" />
          <span class="ml-2 text-gray-600 align-middle">{{ $t('automation.flow.header.saving') }}...</span>
        </div>
      </CCol>
      <CCol class="left-separator" md="3">
        <CRow class="align-items-center">
          <CCol md="2">
            <ApexChart width="70" type="radialBar" :options="options" :series="series" />
          </CCol>
          <CCol>
            <span class="h6">{{ validationStatus }}/{{ maxSteps }} {{ $t('automation.flow.header.complete') }}</span>
          </CCol>
        </CRow>
      </CCol>
      <CCol md="6" class="text-right">
        <CButton class="px-4 mr-3 py-2" color="gray-700" variant="outline" @click="redirectToAutomationList">
          <CIcon name="cross" size="custom-size" :height="12" viewBox="0 0 32 32" />
          <span class="ml-2">{{ $t('automation.flow.header.close') }}</span>
        </CButton>
        <CButton v-if="workflowMode !== WORKFLOW_MODES.VIEW" class="px-4 py-2" color="primary" :disabled="validationStatus != 4 || loading" @click="finishAutomation">
          <CSpinner v-if="loading" class="align-middle" color="white" style="width: 1rem; height: 1rem" />
          <CIcon v-else name="checkMark" size="custom-size" :height="12" viewBox="0 0 32 32" />
          <span class="ml-2">{{ $t('automation.flow.header.save') }}</span>
        </CButton>
      </CCol>
      <CCol md="12" class="text-right">
        <transition name="fade">
          <MenssageAlert :messages="messages" />
        </transition>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import ApexChart from 'vue-apexcharts'
import { mapState } from 'vuex'
import MenssageAlert from '@/components/MenssageAlert'
import getAutomationBadge from '../../utils/getAutomationBadge'
import { WORKFLOW_MODES } from '../../constants'

export default {
  components: {
    ApexChart,
    MenssageAlert,
  },
  props: {
    isLoadingSave: {
      type: Boolean,
      default: false,
    },
    workflowMode: {
      type: Number,
    }
  },
  data() {
    return {
      loading: false,
      series: [0],
      options: {
        chart: {
          height: '100%',
          type: 'radialBar',
          sparkline: {
            enabled: true,
          },
        },

        colors: ['#37B24D'],

        plotOptions: {
          radialBar: {
            hollow: {
              margin: 1000,
              size: '50%',
              position: 'back',
            },

            track: {
              background: '#EDFDEF',
              margin: 1,
            },

            dataLabels: {
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
          },
        },
      },
      maxSteps: 4,
      messages: [],
      WORKFLOW_MODES: WORKFLOW_MODES
    }
  },
  mounted() {
    this.series = [this.validationSteps]
  },
  computed: {
    ...mapState({
      automationDetail: (state) => state.automation.controls.validation.automationDetail,
      audience: (state) => state.automation.controls.validation.audience,
      action: (state) => state.automation.controls.validation.action,
      content: (state) => state.automation.controls.validation.content,
    }),
    badgeByStatus() {
      const workflowStatus = this.$store.state.automation.mainWorkflow.workflowStatus
      return getAutomationBadge(workflowStatus)
    },
    validationSteps: function () {
      let result = 0
      result += this.automationDetail ? 25 : 0
      result += this.audience ? 25 : 0
      result += this.action ? 25 : 0
      result += this.content ? 25 : 0
      return result
    },
    validationStatus() {
      let result = 0
      result += this.automationDetail ? 1 : 0
      result += this.audience ? 1 : 0
      result += this.action ? 1 : 0
      result += this.content ? 1 : 0
      return result
    },
  },
  watch: {
    validationSteps() {
      this.series = [this.validationSteps]
    },
  },
  methods: {
    redirectToAutomationList() {
      return this.$router.push({ name: 'automationList' })
    },
    finishAutomation() {
      this.loading = true

      let { organizationId, workflowId } = this.$route.params

      this.$store
        .dispatch('automation/finishAutomation', { organizationId, workflowId })
        .then(() => this.$router.push({ name: 'automationList' }))
        .catch(({ response }) => {
          this.messages = [
            {
              status: 'danger',
              text: this.$t(`general.errors.${response.data.message}`),
            },
          ]
        })
        .finally(() => (this.loading = false))
    },
  },
}
</script>
<style lang="scss">
.left-separator {
  border-left: 1px $gray-200 solid;
}
</style>
